import axios from "axios";
import authHeader from "../../Services/auth-header";
import { refreshToken } from "../../Services/auth.service";
import { baseURLDeleteFile } from "../../Services/client";

export function createSetDeleteUploaded({
  setDeleteUploadPdfUrl,
  setDeleteUploadPdfIndex,
  setDeleteUploadImageUrl,
  setDeleteUploadImageIndex,
}) {
  return function setDeleteUploaded(fileUrl, freeIndex, PDFOrImg) {
    if (PDFOrImg === 1) {
      setDeleteUploadPdfUrl(fileUrl);
      setDeleteUploadPdfIndex(freeIndex);
    } else {
      setDeleteUploadImageUrl(fileUrl);
      setDeleteUploadImageIndex(freeIndex);
    }
  };
}

export function createDeleteUploadedImg({
  uploadedImagesFile,
  uploadedImagesURL,
  setUploadedImagesURL,
  setUploadedImagesFile,
  setUploadedImagesList,
  setUploadedImagesNamesList,
  setDeleteUploadImageUrl,
  setDeleteUploadImageIndex,
}) {
  return function deleteUploadedImg(
    uploadedImagesList1,
    uploadedImagesNamesList1,
    fileUrl,
    index
  ) {
    let promise2 = new Promise((resolve, reject) => {
      if (fileUrl !== "") {
        axios
          .delete(baseURLDeleteFile, {
            params: {
              url: fileUrl,
            },
            headers: authHeader(),
          })
          .then((response) => {
            resolve();
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  deleteUploadedImg(
                    uploadedImagesList1,
                    uploadedImagesNamesList1,
                    fileUrl,
                    index
                  );
                  reject();
                } else {
                  resolve();
                }
              });
            } else {
              resolve();
            }
          });
      } else {
        resolve();
      }
    });
    promise2.then(() => {
      let tempArray = [...uploadedImagesList1];
      let tempArrayNames = [...uploadedImagesNamesList1];
      let tempArrayFiles = [...uploadedImagesFile];
      let tempArrayURLs = [...uploadedImagesURL];

      delete tempArray[index];
      delete tempArrayNames[index];
      delete tempArrayFiles[index];
      delete tempArrayURLs[index];

      setUploadedImagesURL(tempArrayURLs);
      setUploadedImagesFile(tempArrayFiles);
      setUploadedImagesList(tempArray);
      setUploadedImagesNamesList(tempArrayNames);
      setDeleteUploadImageUrl("");
      setDeleteUploadImageIndex(-1);
    });
  };
}
